var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.403 3.166a1.825 1.825 0 0 1 1.733.114l11.665 7.5c.217.138.393.321.514.534a1.371 1.371 0 0 1 0 1.373 1.558 1.558 0 0 1-.514.534L7.137 20.72a1.824 1.824 0 0 1-1.732.114 1.611 1.611 0 0 1-.66-.553 1.39 1.39 0 0 1-.244-.782V4.501c0-.276.084-.546.243-.781a1.61 1.61 0 0 1 .66-.554Z"
})));
export default SvgPlay;